module.exports = __webpack_public_path__ + "static/dashboard_screen_v2-ef342407f33dca5f41c28edeef32db54.png";